import React from 'react';

const IconFreeCodeCamp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 712 484">
    <title>FreeCodeCamp</title>
    <defs>
      <path id="a1UGBK5Jf" d="M136.83 9.96C139.18 12.3 141.53 15.67 141.54 19.06C141.55 24.92 134.67 32.87 121.95 45.93C68.91 97 42.23 159.54 42.41 234.97C42.61 318.42 70.67 385.44 125.21 437.38C136.68 447.63 141.39 455.69 141.41 462.59C141.41 465.97 139.08 469.49 136.74 472.88C134.54 475.23 129.85 477.59 126.47 477.59C113.85 477.62 96.19 462.7 73.13 433.67C28.23 378.64 7.93 317.87 6.79 235.05C5.74 152.19 31.72 96 82.57 37.99C100.87 17.26 116.13 6.49 126.54 6.47C129.92 6.46 133.44 7.62 136.83 9.96Z"/>
      <path id="a8LR3SBcZL" d="M415.42 249.9C395.49 244.81 477.27 148.19 331.92 32.51C331.92 32.51 350.99 93.1 254.83 228.31C158.62 363.47 297.61 443.99 297.61 443.99C297.61 443.99 232.38 409.23 308.21 285.47C321.78 263.02 339.54 242.69 361.59 196.93C361.59 196.93 381.11 224.48 370.92 284.21C355.68 374.47 437.01 348.64 438.27 349.9C466.68 383.35 414.74 442.14 411.58 443.99C408.43 445.79 559.91 352.87 452.29 213.03C444.92 220.4 435.34 255 415.42 249.9Z"/>
      <path id="eYLbcOweH" d="M575.26 9.9C572.91 12.24 570.56 15.61 570.55 19C570.54 24.86 577.42 32.81 590.14 45.87C643.18 96.93 669.86 159.48 669.68 234.91C669.48 318.36 641.42 385.38 586.88 437.32C575.41 447.57 570.7 455.63 570.68 462.53C570.68 465.91 573.01 469.43 575.35 472.82C577.55 475.17 582.24 477.52 585.62 477.53C598.24 477.56 615.9 462.64 638.96 433.61C683.86 378.58 704.16 317.81 705.3 234.99C706.35 152.13 680.37 95.94 629.52 37.93C611.22 17.2 595.96 6.43 585.55 6.41C582.17 6.4 578.65 7.56 575.26 9.9Z"/>
    </defs>
    <g>
      <g>
        <g>
          <use fill="#none" fillOpacity="1" opacity="1" href="#a1UGBK5Jf"/>
          <g>
            <use fillOpacity="0" stroke="currentColor" strokeOpacity="0" strokeWidth="1" opacity="1" href="#a1UGBK5Jf"/>
          </g>
        </g>
        <g>
          <use fill="#none" fillOpacity="1" opacity="1" href="#a8LR3SBcZL"/>
          <g>
            <use fillOpacity="0" stroke="currentColor" strokeOpacity="0" strokeWidth="1" opacity="1" href="#a8LR3SBcZL"/>
          </g>
        </g>
        <g>
          <use fill="#none" fillOpacity="1" opacity="1" href="#eYLbcOweH"/>
          <g>
            <use fillOpacity="0" stroke="currentColor" strokeOpacity="0" strokeWidth="1" opacity="1" href="#eYLbcOweH"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconFreeCodeCamp;